<h4   class="page-title" *ngIf="exibirTitulo">Cupons</h4>

<div class="card">
  <div class="card-body">
    <app-grid-cupons #gridGruponsAtivos></app-grid-cupons>
  </div>
</div>
